export class ApiError extends Error {
  status: number;
  code?: string;
  details?: unknown;

  constructor(message: string, status: number, code?: string, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export async function toApiError(response: Response): Promise<ApiError> {
  let body: unknown = null;
  let message = `Request failed with status ${response.status}`;

  try {
    body = await response.json();
    if (body && typeof body === 'object') {
      const maybeBody = body as Record<string, unknown>;
      const maybeMessage = maybeBody.message;

      if (Array.isArray(maybeMessage)) {
        message = maybeMessage.join(', ');
      } else if (typeof maybeMessage === 'string' && maybeMessage.trim()) {
        message = maybeMessage;
      }
    }
  } catch {
    // Fall back to generic message when response body is not JSON.
  }

  const code =
    body && typeof body === 'object' && typeof (body as Record<string, unknown>).code === 'string'
      ? ((body as Record<string, unknown>).code as string)
      : undefined;

  return new ApiError(message, response.status, code, body);
}
